export default "__VITE_ASSET__DDVU8LnD__";